import api from './api';
import publicApi from './publicApi';

export const tableService = {
  // Admin Table Management
  getAdminTables: async (outletId = null) => {
    const params = outletId ? { outlet_id: outletId } : {};
    const response = await api.get('/tables/admin/tables', { params });
    return response.data;
  },

  createTable: async (tableData) => {
    const formData = new FormData();
    Object.keys(tableData).forEach(key => {
      if (tableData[key] !== null && tableData[key] !== undefined) {
        formData.append(key, tableData[key]);
      }
    });

    const response = await api.post('/tables/admin/tables', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },

  updateTable: async (tableId, tableData) => {
    const formData = new FormData();
    Object.keys(tableData).forEach(key => {
      if (tableData[key] !== null && tableData[key] !== undefined) {
        formData.append(key, tableData[key]);
      }
    });

    const response = await api.put(`/tables/admin/tables/${tableId}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },

  deleteTable: async (tableId) => {
    const response = await api.delete(`/tables/admin/tables/${tableId}`);
    return response.data;
  },

  // Public Table Operations
  getPublicTables: async (outletId) => {
    const response = await api.get(`/tables/public/outlets/${outletId}/tables`);
    return response.data;
  },

  checkTableAvailability: async (availabilityData) => {
    const response = await api.post('/tables/public/check-availability', availabilityData);
    return response.data;
  },

  createTableReservation: async (reservationData) => {
    const response = await api.post('/tables/public/reservations', reservationData);
    return response.data;
  },

  createReservationRequest: async (requestData) => {
    const response = await publicApi.post('/public/booking-request', requestData);
    return response.data;
  },

  // Admin Reservation Management
  // getAdminReservations: async (outletId = null, status = null,fromDate = null,toDate = null) => {
  //   const params = {};
  //   params.outlet_id = outletId;
  //   if (status) params.status = status;
  //   if (fromDate) params.from_date = fromDate;
  //   if (toDate) params.to_date = toDate;

  //   const response = await api.get('/reservations/admin', { params });
  //   // console.log("Ress Response => " , response)
  //   return response.data;

  // },

  getAdminReservations: async (outletId = null, status = null, fromDate = null, toDate = null, page = 1, perPage = 10) => {
    const params = {};
    params.outlet_id = outletId;
    if (status) params.status = status;
    if (fromDate) params.from_date = fromDate;
    if (toDate) params.to_date = toDate;
    params.page = page;
    params.per_page = perPage;
 
    const response = await api.get('/reservations/admin', { params });
    // console.log("Ress Response => " , response)
    return response.data;
 
  },

  updateReservationStatus: async (reservationId, status, adminNotes = null) => {
    const formData = new FormData();
    formData.append('status', status);
    if (adminNotes !== null) {
      formData.append('admin_notes', adminNotes);
    }

    const response = await api.patch(`/tables/admin/reservations/${reservationId}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },

  // Public Table Order Access
  getTableOrderPage: async (uniqueString) => {
    const response = await publicApi.get(`/tables/public/table-order/${uniqueString}`);
    return response.data;
  },

  // Reservation Availability Check
  checkAvailability: async (date) => {
    const response = await api.get(`/reservations/availability/${date}`);
    return response.data;
  },

  // Create Reservation (Admin)
  createReservation: async (reservationData) => {
    const response = await api.post('/reservations/', reservationData);
    return response.data;
  },

  // Update Reservation Status (Admin)
  updateReservationStatus: async (reservationId, status, additionalData = {}) => {
    const response = await api.patch(`/reservations/${reservationId}`, {
      status,
      ...additionalData
    });
    return response.data;
  },

  // Assign Table to Booking Request (Admin)
  assignTableToRequest: async (requestId, tableId) => {
    const response = await api.patch(`/reservations/${requestId}/assign-table`, {
      table_id: tableId,
      status: 'confirmed'
    });
    return response.data;
  },

  tableOrderStatusCheck: async (payload) => {
    try {
      const response = await api.post('/table_order/table_status', payload)
      return response
    }
    catch (error) {
      throw new Error(error)
    }
  },

  newTableOrder: async (payload) => {
    try {
      const response = await api.post('/table_order/create_table_order', payload);
      return response
    }
    catch (error) {
      throw new Error(error)
    }
  },

  getTableCartItems: async (table_id) => {
    let payload = {
      "table_id": table_id
    }
    try {
      const response = await api.post('/table_order/get_table_cart_items', payload);
      return response
    }
    catch (error) {
      throw new Error(error)
    }
  },

  addNewItemInOrder: async (payload) => {
    try {
      const response = await api.put('/table_order/add_new_item', payload);
      return response
    }
    catch (error) {
      throw new Error(error)
    }
  },


  removeOrderItem: async (payload) => {
    try {
      // console.log("Payload Here => ", payload);
      const response = await api.delete(
        '/table_order/remove_item',
        {
          data: payload
        }
      );

      return response;
    } catch (error) {
      throw new Error(error);
    }
  },


  handleQuantityChange: async (payload) => {
    try {
      const response = await api.put('/table_order/edit_quantity_table_order', payload);
      return response
    }
    catch (error) {
      throw new Error(error)
    }
  },

  tableOrderStatusChange: async (table_id, order_id) => {
    try {
      const response = await api.post(`/table_order/change_table_order_status/${table_id}/${order_id}`);
      return response
    }
    catch (error) {
      throw new Error(error)
    }
  },

  closeBill: async (payload) => {
    try {
      const response = await api.put('/table_order/close_bill', payload);
      return response
    }
    catch (error) {
      console.error("Error While Closing Bill => ", error);
      throw new Error(error.response.data.detail)
    }
  },

  tableCheckout: async (payload) => {
    try {
      const response = await api.post('/table_order/checkout_table_order', payload);
      return response
    }
    catch (error) {
      console.error("Error While Closing Bill => ", error);
    }
  },

  confirmOrderItems: async (tableOrderId) => {
    try {
      const response = await api.post(`/table_order/confirm_items/${tableOrderId}`);
      return response
    }
    catch (error) {
      console.error("Error While Confirm Items => ", error);
    }
  },

  downloadTableQRCode: async (tableId) => {
    try {
      const response = await api.post(
        "/tables/download_table_qr",
        {
          table_id: tableId,
        },
        {
          responseType: "blob",
        }
      );

      const blob = new Blob(
        [response.data],
        { type: "application/pdf" }
      );

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = `table_${tableId}_qr.pdf`;

      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      return true;
    } catch (error) {
      console.error("Download failed:", error);
      return false;
    }
  }

};



